import React, { ReactNode } from "react";
import { HeaderSC, MainSC, SectionSC, SidebarSC } from "./Styled";

interface VideoLayoutProps {
    header: ReactNode;
    sideBar: ReactNode;
    children: ReactNode;
}

export const VideoLayout: React.FC<VideoLayoutProps> = ({
    header: Header,
    sideBar: Sidebar,
    children,
}) => {
    return (
        <MainSC>
            <HeaderSC>{Header}</HeaderSC>
            <SidebarSC>{Sidebar}</SidebarSC>
            <SectionSC>{children}</SectionSC>
        </MainSC>
    );
};
